import React from 'react';

export default ({ value, onChange, onKeyUp, placeholder }) => {
  return (
    <div className="synonym-list-input">
      <input
        value={value}
        onChange={onChange}
        onKeyUp={onKeyUp}
        type="text"
        placeholder={placeholder || 'Add a new synonym...'}
      />
    </div>
  );
};
